import { render, staticRenderFns } from "./savedItems.vue?vue&type=template&id=4f932412&scoped=true&"
import script from "./savedItems.vue?vue&type=script&lang=js&"
export * from "./savedItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f932412",
  null
  
)

export default component.exports